<div class="vc-field">
   <label
      *ngIf="label"
      class="vc-label">
      {{ label }}
      <span
         *ngIf="required"
         class="required-asterisk">
         *
      </span>
   </label>
   <textarea
      pInputTextarea
      [class]="inputStyleClass"
      [rows]="rows"
      [autoResize]="autoResize"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [ngModel]="value ?? ''"
      [required]="required"
	  [maxlength]="maxlength"
      (ngModelChange)="onChange($event)"
      (blur)="onTouched()"
      #ngModelCtrl="ngModel"
      [class.invalid]="required && ngModelCtrl.invalid && (ngModelCtrl.touched || ngModelCtrl.dirty)"></textarea>
</div>
